/* istanbul ignore file */
import styled from 'styled-components';
import { Grid } from '@econsult/econsult-ui/dist/components/Grid';
import Skeleton from '@mui/material/Skeleton';
import { HeadingOne, Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';

export const GridContainer = styled(Grid)`
  background-color: white;
`;

export const Heading = styled(HeadingOne)`
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 36px;
  color: #1E194B;
  font-weight: 600;
`;

export const InfoParagraph = styled(Paragraph)`
  padding: 1rem;
  font-size: 16px;
  font-weight: 800;
`;

export const LoadingIndicator = styled(Skeleton)`
  width: flex1;
  height: 20rem;
`;
